export const updateCurrentProductionDayGiveNewState = (productionDay,currentProductionDay)=>{

    const updatedProductionDay = {...productionDay};

    updatedProductionDay.productionDays[currentProductionDay.id] = currentProductionDay

    return updatedProductionDay;

}